
















































import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component
export default class EditCorp extends BaseComponent {
    // @Prop({ default: false }) private is_display!: boolean;
    @Prop({ default: '' }) private corp_name!: string;
    @Prop({ default: '' }) private corp_account!: string;

    private edit_corp_name: string = '';
    private edit_corp_account: string = '';

    @Prop({ default: -1 }) private corp_id!: number;
    private isFormValid: boolean = false; // バリデーション状態でボタンを有効化する為のフラグ
    private is_display: boolean = true;

    created() {
        this.edit_corp_name = this.corp_name;
        this.edit_corp_account = this.corp_account;
    }
    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }

    // 会社編集
    private async corpEdit() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                corp_id: this.corp_id,
                corp_name: this.edit_corp_name,
                corp_account: this.edit_corp_account,
            };
            const resp: AxiosResponse<any> = await this.$http.post('corp_edit.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.$emit('closeDialog', true);
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: '会社編集失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: '会社編集失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
